<template>
    <div class="NavCtrls">
        <arrow-bttn
            class="NavCtrls-back"
            :light="light"
            :disabled="disableBack"
            @click="$emit('back')"
            up
        ></arrow-bttn>
        <arrow-bttn
            class="NavCtrls-next"
            :light="light"
            :disabled="disableNext"
            @click="$emit('next')"
        ></arrow-bttn>
    </div>
</template>

<script>
import ArrowBttn from '@/app/components/ArrowBttn'
export default {
    name: 'NavCtrls',
    props: {
        disableBack: {
            type: Boolean,
            default: false,
        },
        disableNext: {
            type: Boolean,
            default: false,
        },
        light: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ArrowBttn,
    },
}
</script>

<style src="styles/components/NavCtrls.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/NavCtrls.vue